<script setup>
import { get_faqs } from '@/services/faqs';
import { create_term, delete_term, get_terms, update_term } from '@/services/terms';
import { onMounted, ref } from 'vue';

const form = ref({
  name: '',
  status: 'new',
  id: ''
})
const taxonomy = 'faq_category'
const terms = ref([])
const isLoading = ref(true)
onMounted(async()=>{
  let response = await get_terms(taxonomy)
  if(!response.error){
    console.log("🚀 ~ onMounted ~ response.result:", response.result)
    terms.value = response.result.data.data
  }else{
    Swal.fire({
      title: 'Error',
      text: 'An error occur',
      icon: 'error'
    })
  }
  isLoading.value = false
})

async function addCategory(){
  isSubmitting.value = true
  let term = {
    name: form.value.name,
    term_taxonomy_attributes: {
      taxonomy
    }
  }
  if (form.value.status == 'new'){
    let response = await create_term(term)
    if (!response.error){
      terms.value.push(response.result.data.data)
      Swal.fire({
        title: 'Created',
        text: 'Category added',
        icon: 'success'
      })
    }else{
      Swal.fire({
        title: 'Error',
        text: 'Error occur',
        icon: 'error'
      })
    }
  }else{
    let response = await update_term(form.value.id, term)
    let tempTerm = response.result.data.data
    terms.value = terms.value.map(term => {
      if (term.id == tempTerm.id){
        return tempTerm
      }else{
        return term
      }
    })
  }
  form.value = {
    id: '',
    status: 'new',
    name: '',
  }
  isSubmitting.value = false
}

async function deleteTerm(index, term_id){
  let response = await delete_term(term_id)
  if (response.error){
    Swal.fire({
      title: 'Error',
      html: response.result.error,
      icon: 'error'
    })
  }else{
    Swal.fire({
      title: 'Deleted',
      text: 'Age group successfully deleted',
      icon: 'success'
    })
    terms.value.splice(index, 1)
  }
}

function editTerm(termObj){
  form.value.name = termObj.attributes.name
  form.value.status = 'edit'
  form.value.id = termObj.id
}
const isSubmitting = ref(false)
</script>

<template>
  <Breadcrumbs main="FAQ Categories"/>
  
  <LoadingCard v-if="isLoading" />
  <div v-else class="container-fluid">
    <div class="row">
      <!-- Form  -->
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="addCategory()">
              <input type="text" name="title" id="title" class="form-control" placeholder="Category name" v-model="form.name">
              <button :disabled="isSubmitting" class="mt-2 btn btn-light-success" type="submit">
                <div v-if="isSubmitting" class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <template v-else>
                  <template v-if="form.status == 'new'">
                    Add Category
                  </template>
                  <template v-else>
                    Update Category
                  </template>
                </template>
              </button>
            </form>
          </div>
        </div>
      </div>
      <!-- List -->
      <div class="col-md-8">
        <div class="card" v-auto-animate>
          <div class="card-header py-3">
            <h4 class="mb-0">FAQ Category List</h4>
          </div>
          <template v-if="terms.length == 0">
            <div class="card-body">
              <emptyCard :link="{
                routerObj: {name: 'faq-categories'}, type: 'link', desc: 'Add Categories', class: 'w-25'
                }" 
              />
            </div>
          </template>
          <div v-else class="card-body" v-auto-animate>
            <div class="row border-bottom py-2" v-for="(cat, index) in terms" :key="cat.id">
              <div class="col-8">
                <p class="text-truncate">{{ cat.attributes.name }}</p>
              </div>
              <div class="col-4 d-flex justify-content-end">
                <button class="btn btn-light-warning icon-btn me-1" @click="editTerm(cat)">
                  <vue-feather type="edit-2" size="1rem"/>
                </button>
                <button class="btn btn-light-danger icon-btn" @click="deleteTerm(index, cat.id)">
                  <vue-feather type="trash" size="1rem"/>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>